import React, { useState } from "react";
import Header from "../../components/Header";
import Watermark from '../../assets/Watermark.png';
import InvitedUsers from "../../components/UserManagment/InvitedUsers";
import RegisteredUsers from "../../components/UserManagment/RegisteredUsers";
import AdminUsers from "../../components/AdminManagment/AdminUsers";
import FacultyUsers from "../../components/AdminManagment/Faculty";

export default function AdminManagment() {

    const [activeTab, setActiveTab] = useState("Admin");
    const [counter, setCounter] = useState(0);



    return (
        <div
            className="p-4 space-y-4"
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                backgroundImage: `url(${Watermark})`,
                backgroundSize: '45%',
                backgroundPosition: 'center 20px',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <Header />

            {/* Tabs */}
            <div className="flex mb-6 overflow-hidden rounded-t-lg ">
                <button
                    className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "Admin"
                        ? "bg-[#900028] text-white"
                        : "bg-[#F2C7C9] bg-opacity-60 text-black-900 border-black"
                        }`}
                    onClick={() => {
                        setActiveTab("Admin")
                        setCounter(prev => prev + 1);
                    }}
                >
                    Admin Users
                </button>
                <button
                    className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "Faculty"
                        ? "bg-[#900028] text-white"
                        : "bg-[#F2C7C9] bg-opacity-60 text-black-900 border-black"
                        }`}
                    onClick={() => {
                        setActiveTab("Faculty");
                        setCounter(prev => prev + 1);
                    }}
                >
                    Faculty
                </button>
            </div>


            {activeTab === "Admin" ? (
                <AdminUsers/>
            ) : (
                <FacultyUsers/>
            )}


        </div>
    );
}
